import(/* webpackMode: "eager" */ "/app/src/app/[locale]/p/page.tsx");
